import React, { useState, useEffect, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Sidebar from "../Components/Sidebar/Sidebar";
import Form from "react-bootstrap/Form";
import { Roller } from "react-awesome-spinners";
import { getBookingList, getDownloadBookingList } from "../Api/bookingApi";
import { CSVLink } from "react-csv";
import { Spinner } from "react-bootstrap";

const BookingReport = () => {
  const [verifyPassword, setVerifyPassword] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    const first = new Date(date.getFullYear(), date.getMonth(), 1);
    return first.toISOString().split("T")[0]; // YYYY-MM-DD
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return last.toISOString().split("T")[0]; // YYYY-MM-DD
  });

  const [tableConfig, setTableConfig] = React.useState({
    page: 1,
    sizePerPage: 10,
    filters: {},
    sortField: "",
    sortOrder: "",
    bookingStage: statusFilter,
    clientStage: "",
  });
  const preventApiTrigger = useRef(false);
  const [pageOption, setPageOption] = React.useState({
    totalSize: 0,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  });
  const [bookingData, setBookingData] = useState([]);
  const [debouncedText, setDebouncedText] = useState("");

  // Password verification handler
  const handlePasswordVerify = () => {
    const correctPassword = "Tony#2025"; // Change this to your desired password

    if (passwordInput === correctPassword) {
      setVerifyPassword(true);
      setPasswordError("");
    } else {
      setPasswordError("Incorrect password. Please try again.");
      setPasswordInput("");
    }
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlePasswordVerify();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  const statusFormatter = (cell, row) => {
    let badgeClass = "";
    let booking_status = "";
    switch (row.booking_status) {
      case "A":
        booking_status = "Active";
        badgeClass = "badge bg-success";
        break;
      case "C":
        booking_status = "Confirm";
        badgeClass = "badge bg-warning text-dark";
        break;
      case "R":
        booking_status = "Reject";
        badgeClass = "badge bg-info";
        break;
      case "CC":
        booking_status = "Cancel by Client";
        badgeClass = "badge bg-danger";
        break;
      case "CS":
        booking_status = "Cancel by service provider";
        badgeClass = "badge bg-danger";
        break;
      case "CO":
        booking_status = "Completed";
        badgeClass = "badge bg-danger";
        break;
      case "MN":
        booking_status = "Mark as no show";
        badgeClass = "badge bg-danger";
        break;
      case "RS":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-danger";
        break;
      case "UC":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-danger";
        break;
      case "Q":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-danger";
        break;
      default:
        badgeClass = "badge bg-secondary";
    }

    return <span className={badgeClass}>{booking_status}</span>;
  };

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: false,
      visible: true,
      formatter: (cell, row, index) => index + 1,
    },
    {
      dataField: "booking_date_time",
      text: "DATE",
      sort: true,
      visible: true,
    },
    {
      dataField: "first_name",
      text: "NAME",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.first_name + " " + row.last_name,
    },
    {
      dataField: "user_email",
      text: " EMAIL",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.user_email,
    },
    {
      dataField: "phone",
      text: "PHONE",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.phone,
    },
    {
      dataField: "booking_status",
      text: "BOOKING STATUS",
      sort: true,
      formatter: statusFormatter,
      visible: true,
    },
    {
      dataField: "customer_stage",
      text: "CLIENT STAGE",
      sort: true,
      visible: true,
    },
    {
      dataField: "given_name",
      text: "FSR",
      sort: true,
      visible: true,
      formatter: (cell, row) => row.given_name || "-",
    },
    {
      dataField: "coupon_code",
      text: "COUPON CODE",
      sort: true,
      visible: true,
    },
    {
      dataField: "app_notes",
      text: "Note",
      sort: false,
      visible: true,
    },
    // new colum for billed_amount 
    {
      dataField: "billed_amount",
      text: "BILLED AMOUNT",
      sort: false,
      visible: true,
    },
    {
      dataField: "book_date",
      text: "Booked On",
      sort: false,
      visible:true
    }
  ];
  const visibleColumns = columns.filter((col) => col.visible);

  const pagination = paginationFactory({
    ...pageOption,
    page: tableConfig.page,
    sizePerPage: tableConfig.sizePerPage,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });

  const clearFilters = () => {
    setSearchText("");
    setStatusFilter("all");
    setStartDate("");
    setEndDate("");
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    if (preventApiTrigger.current) {
      preventApiTrigger.current = false;
      return;
    }

    const newPage = type === "filter" ? 1 : page;

    let newSortOrder = sortOrder;
    if (sortField === tableConfig.sortField) {
      newSortOrder = tableConfig.sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }

    let safeSortField = sortField ?? "";
    let safeSortOrder = newSortOrder ?? "";

    if (safeSortField === "") {
      safeSortField = "";
    }

    if (safeSortOrder === "") {
      safeSortOrder = "";
    }

    if (statusFilter === "") {
      setStatusFilter("all");
    }
    const updatedConfig = {
      ...tableConfig,
      page: newPage,
      sizePerPage,
      sortField: safeSortField,
      sortOrder: safeSortOrder,
    };
    try {
      setTableConfig(updatedConfig);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }

    getBookingData(
      newPage,
      sizePerPage,
      updatedConfig.filters,
      safeSortField,
      safeSortOrder,
      debouncedText,
      updatedConfig.bookingStage,
      updatedConfig.clientStage,
      startDate,
      endDate
    );
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const getBookingData = async (
    page,
    sizePerPage,
    filters,
    sortField,
    sortOrder,
    bookingStage = "",
    clientStage = ""
  ) => {
    try {
      console.log("aminesh date startDate", startDate);
      console.log("aminesh date endDate", endDate);
      setLoading(true);
      const formData = new URLSearchParams();
      formData.append("start_date", startDate ? startDate : "2025-10-01");
      formData.append("end_date", endDate ? endDate : "2025-12-30");
      formData.append("page", page || 1);
      formData.append("page_size", sizePerPage || 10);
      formData.append("filters", JSON.stringify(filters) || "");

      formData.append("order_by", sortField || "");
      formData.append("order_type", sortOrder || "");
      formData.append("searchText", debouncedText || "");
      formData.append("bookingStage", statusFilter || "");
      formData.append("clientStage", clientStage || "all");

      getBookingList(formData).then((res) => {
        if (res.code === 200) {
          setLoading(false);
          const apiResponse = res.data;
          setBookingData(apiResponse.data.bookings);
          setPageOption({
            totalSize: apiResponse.data.total_rows,
            hideSizePerPage: false,
            hidePageListOnlyOnePage: true,
          });
        }
      });
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (verifyPassword) {
      getBookingData(
        tableConfig.page,
        tableConfig.sizePerPage,
        tableConfig.filters,
        tableConfig.sortField,
        tableConfig.sortOrder,
        debouncedText,
        tableConfig.bookingStage,
        tableConfig?.clientStage
      );
    }
  }, [
    tableConfig,
    startDate,
    endDate,
    debouncedText,
    statusFilter,
    verifyPassword,
  ]);

  const [csvReportData, setCsvReportData] = useState([]);
  const [csvLoader, setCsvLoader] = useState(false);
  const csvLinkRef = useRef();

  const getAllData = async () => {
    setCsvLoader(true);
    const formData = new URLSearchParams();
    formData.append("start_date", startDate ? startDate : "2025-10-01");
    formData.append("end_date", endDate ? endDate : "2025-12-30");
    formData.append("page", tableConfig.page || 1);
    formData.append("page_size", tableConfig.sizePerPage || 10);
    formData.append("filters", JSON.stringify(tableConfig.filters) || "");

    formData.append("order_by", tableConfig.sortField || "");
    formData.append("order_type", tableConfig.sortOrder || "");
    formData.append("searchText", debouncedText || "");
    formData.append("bookingStage", statusFilter || "");
    formData.append("clientStage", "all");
    try {
      const res = await getDownloadBookingList(formData);
      if (res.code === 200) {
        const apiResponse = res.data;
        setCsvReportData(apiResponse.data.bookings);

        setTimeout(() => {
          csvLinkRef.current.link.click();
        }, 200);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCsvLoader(false);
    }
  };

  const csvReport = {
    data: csvReportData.map((item) => ({
      name: (item.first_name || "").trim(),
      email: (item.user_email || "").trim(),
      phone: (item.phone || "").trim(),
      customer_stage: (item.customer_stage || "").trim(),
      booking_status: (item.booking_status || "").trim(),
      booking_date_time: (item.booking_date_time || "").trim(),
      coupon_code: (item.coupon_code || "").trim(),
      app_notes: (item.app_notes || "").trim(),
      billed_amount: (item.billed_amount || "").trim(),
      book_date: (item.book_date || "").trim(),
      
    })),
    headers: [
      { label: "NAME", key: "name" },
      { label: "EMAIL", key: "email" },
      { label: "PHONE", key: "phone" },
      { label: "CUSTOMER STAGE", key: "customer_stage" },
      { label: "BOOKING STATUS", key: "booking_status" },
      { label: "BOOKING DATE", key: "booking_date_time" },
      {label: "PROMO CODE", key: "coupon_code"},
      {label: "Note", key: "app_notes"},
      {label: "BILLED AMOUNT", key: "billed_amount"},
      {label: "BOOKED ON", key: "book_date"},
      { label: "PROMO CODE", key: "coupon_code" },
      { label: "Note", key: "app_notes" },
    ],
    filename: "BookingData.csv",
  };

  // Password verification screen - render within the dashboard layout
  const renderPasswordScreen = () => (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "80vh" }}
    >
      <div className="card" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="card-body p-5">
          <div className="text-center mb-4">
            <h3 className="fw-bold">Booking Report Access</h3>
            <p className="text-muted">Please enter the password to continue</p>
          </div>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              onKeyPress={handleKeyPress}
              autoFocus
              isInvalid={!!passwordError}
            />
            {passwordError && (
              <Form.Control.Feedback type="invalid">
                {passwordError}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <button
            className="btn btn-primary add-user-btn m-0 w-100"
            onClick={handlePasswordVerify}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );

  // Main booking report screen
  return (
    <div>
      {loading ? (
        <div className="loading">
          <Roller />
        </div>
      ) : (
        <div className="dashboard-container d-flex">
          <div className="sidebar-container">
            <Sidebar />
          </div>
          <div className="main-container">
            <div className="main-page-body-content">
              <div className="main-page-body-content-body">
                <div className="main-page-body-content-body-container">
                  <div className="container-fulid">
                    <div className="table-card">
                      <div className="card-body table-card-body">
                        <div className="table-card-header mb-4 d-flex justify-content-between">
                          <h5 className="card-title">Booking Report</h5>
                        </div>
                        <div className="table-card-body-inner">
                          <div className="animated fadeIn">
                            <div className="row">
                              <div className="col-md-12">
                                {!verifyPassword ? (
                                  renderPasswordScreen()
                                ) : (
                                  <div className="card">
                                    <div className="card-header table-card-header">
                                      <div className="row g-4 align-items-center">
                                        <div className="col-md-3">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Search
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Search by name, email, staff..."
                                              onChange={handleChange}
                                            />
                                          </Form.Group>
                                        </div>

                                        <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Client Status
                                            </Form.Label>
                                            <Form.Select
                                              value={statusFilter}
                                              onChange={(e) =>
                                                setStatusFilter(e.target.value)
                                              }
                                            >
                                              <option value="all">
                                                All Status
                                              </option>
                                              <option value="A">Active</option>
                                              <option value="C">Confirm</option>
                                              <option value="R">Reject</option>
                                              <option value="CC">
                                                Cancelled by Client
                                              </option>
                                              <option value="CS">
                                                Cancelled by Service Provider
                                              </option>
                                              <option value="CO">
                                                Completed
                                              </option>
                                              <option value="MN">
                                                Mark as No Show
                                              </option>
                                              <option value="UC">
                                                Confirmed by Client
                                              </option>
                                            </Form.Select>
                                          </Form.Group>
                                        </div>

                                        <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Start Date
                                            </Form.Label>
                                            <Form.Control
                                              type="date"
                                              value={startDate}
                                              onChange={(e) => {
                                                setStartDate(e.target.value);
                                                setTableConfig((prev) => ({
                                                  ...prev,
                                                  page: 1,
                                                }));
                                              }}
                                              placeholder="Select start date"
                                            />
                                          </Form.Group>
                                        </div>

                                        <div className="col-md-3">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              End Date
                                            </Form.Label>
                                            <Form.Control
                                              type="date"
                                              value={endDate}
                                              onChange={(e) => {
                                                setEndDate(e.target.value);
                                                setTableConfig((prev) => ({
                                                  ...prev,
                                                  page: 1,
                                                }));
                                              }}
                                              min={startDate}
                                              placeholder="Select end date"
                                            />
                                          </Form.Group>
                                        </div>
                                        <div className="col-md-1 mt-5">
                                          <button
                                            className="btn btn-primary downloads-btn-preview me-1"
                                            onClick={() => getAllData()}
                                          >
                                            {csvLoader ? (
                                              <Spinner
                                                animation="border"
                                                role="status"
                                                size="sm"
                                                className="me-1 "
                                              />
                                            ) : (
                                              "Export CSV"
                                            )}
                                          </button>

                                          <CSVLink
                                            {...csvReport}
                                            ref={csvLinkRef}
                                            style={{ display: "none" }}
                                          />
                                        </div>
                                        <div className="col-md-1 d-flex align-items-end mt-5">
                                          <button
                                            className="btn btn-secondary w-100"
                                            onClick={clearFilters}
                                          >
                                            Clear
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card-body">
                                      {bookingData && bookingData.length > 0 ? (
                                        <>
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={bookingData}
                                            remote={{
                                              pagination: true,
                                              sort: true,
                                            }}
                                            onTableChange={handleTableChange}
                                            columns={visibleColumns}
                                            pagination={pagination}
                                          />
                                        </>
                                      ) : (
                                        <div className="text-center py-5">
                                          <h5 className="text-muted">
                                            No Data Found
                                          </h5>
                                          <p className="text-muted">
                                            There are no booking records
                                            available matching your filters.
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingReport;